module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-318.9548fd40.jpg";